/**
 * @file paddle hack time line
 * @author wanzhongyun
 */

import React from 'react';
import { IHackTimeLine } from './../../type';

import './style.less';


const HackTimeLine: React.FC<IHackTimeLine> = props => {
    const {
        titleImageUrl,
        simpleImageUrl,
        difficultyImageUrl
    } = props;
    return (
        <div className='paddle-hack-time-line-wrapper'>
            <img className='paddle-hack-time-line-title' src={titleImageUrl} alt='' />
            <img className='paddle-hack-time-line-simple' src={simpleImageUrl} alt='' />
            <img className='paddle-hack-time-line-difficult' src={difficultyImageUrl} alt='' />
        </div>
    );
};

export default HackTimeLine;